(() => {
 'use strict';
 const node=document.querySelector('[data-fr-global-ui-strings]');if(!node)return;
 let copy;try{copy=JSON.parse(node.textContent);}catch{return;}
 if(!copy||copy.locale==='en')return;
 
 if(copy.reviewForm&&typeof copy.reviewForm==='object'){
  const decoder=document.createElement('textarea');
  for(const key of Object.keys(copy.reviewForm)){
   const value=copy.reviewForm[key];
   if(typeof value==='string'&&/&(?:#(?:[0-9]+|x[0-9a-f]+)|[a-z][a-z0-9]+);/i.test(value)){
    decoder.innerHTML=value;copy.reviewForm[key]=decoder.value;
   }
  }
 }
 const labels={'write a review':'write_review','sort by':'sort_by','most recent':'most_recent','highest rating':'highest_rating','lowest rating':'lowest_rating','only pictures':'only_pictures','pictures first':'pictures_first','videos first':'videos_first','most helpful':'most_helpful','be the first to write a review':'no_reviews'};
 const blocked='.jdgm-rev__body,.jdgm-rev__title,.jdgm-rev__author,.jdgm-rev__buyer-badge,.jdgm-rev__reply-content';
 const controls='.jdgm-write-rev-link,.jdgm-sort-dropdown,.jdgm-sort-dropdown-wrapper,.jdgm-rev-widg__sort-wrapper,.jdgm-gallery-title,.jdgm-gallery-title-wrapper,.jdgm-rev-widg__summary-text,button[data-testid="write-review-button"].jm-action-buttons__button,label[for^="jdgm-sort-"],p.jm-no-reviews-state__text';
 let queued=false;
 function translate(){queued=false;document.querySelectorAll(controls).forEach(el=>{
   const walk=document.createTreeWalker(el,NodeFilter.SHOW_TEXT);let n;
   while((n=walk.nextNode())){if(n.parentElement?.closest(blocked))continue;
    const raw=n.nodeValue.trim(),key=labels[raw.toLowerCase()];let value=key?copy[key]:null;
    const sorted=raw.match(/^Sorted by\s+(.+)$/i);if(sorted){const sortKey=labels[sorted[1].toLowerCase()];if(sortKey)value=copy.sorted_by+' '+copy[sortKey];}
    if(value&&raw!==value)n.nodeValue=n.nodeValue.replace(raw,value);
   }
   if(el.matches('select')&&el.getAttribute('aria-label')!==copy.sort_by)el.setAttribute('aria-label',copy.sort_by);
 });
 document.querySelectorAll('.jm-custom-answer-filter[aria-label="Filters"]').forEach(el=>{if(copy.filters)el.setAttribute('aria-label',copy.filters);});
 document.querySelectorAll('.jdgm-prev-badge__text,.fr-product-rating__text,[class*="review-count"],[class*="rating-count"]').forEach(el=>{if(el.closest(blocked))return;const m=el.textContent.trim().match(/^(\d+)\s+reviews?$/i);if(!m)return;const n=Number(m[1]);let plural;try{plural=new Intl.PluralRules(copy.locale).select(n);}catch{plural=n===1?'one':'other';}const template=copy.reviewCounts[plural]||copy.reviewCounts.other;if(template)el.textContent=template.replace(/\d+/g,m[1]);});
 
 if(copy.reviewForm)document.querySelectorAll('.jdgm-write-review-modal').forEach(modal=>{
  // Never touch entered values, textarea text or the merchant product title.
  const walk=document.createTreeWalker(modal,NodeFilter.SHOW_TEXT);let node;
  while((node=walk.nextNode())){
   if(node.parentElement?.closest('input,textarea,.jdgm-write-review-modal__product-title'))continue;
   const raw=node.nodeValue.trim(),value=copy.reviewForm[raw];
   if(typeof value==='string'&&raw!==value)node.nodeValue=node.nodeValue.replace(raw,value);
  }
  [modal,...modal.querySelectorAll('[aria-label],[placeholder],[title]')].forEach(el=>{
   if(el.closest('.jdgm-write-review-modal__product-title'))return;
   for(const attribute of ['aria-label','placeholder','title']){
    const raw=el.getAttribute(attribute),value=copy.reviewForm[raw];
    if(typeof value==='string'&&raw!==value)el.setAttribute(attribute,value);
   }
  });
  const ratingGroups=modal.querySelectorAll('.jdgm-write-review-modal__stars');
  if(ratingGroups.length){
   if(!document.getElementById('fr-review-rating-scale-localization')){
    const style=document.createElement('style');style.id='fr-review-rating-scale-localization';style.textContent=".jdgm-write-review-modal .jdgm-write-review-modal__stars[data-fr-rating-low]::before{content:attr(data-fr-rating-low)!important}.jdgm-write-review-modal .jdgm-write-review-modal__stars[data-fr-rating-high]::after{content:attr(data-fr-rating-high)!important}";document.head.appendChild(style);
   }
   ratingGroups.forEach(group=>{
    for(const [attribute,source]of [['data-fr-rating-low','Poor'],['data-fr-rating-high','Great']]){
     const value=copy.reviewForm[source];if(typeof value==='string'&&group.getAttribute(attribute)!==value)group.setAttribute(attribute,value);
    }
   });
  }
 });
 }
 function queue(){if(!queued){queued=true;requestAnimationFrame(translate);}}
 translate();new MutationObserver(queue).observe(document.body,{subtree:true,childList:true,characterData:true,attributes:true,attributeFilter:['aria-label','placeholder','title']});
})();